module.exports = __webpack_public_path__ + "img/gywm.fb26407d.png";